class PostMessageBus {
  constructor(config = {}) {
    this.origin = new URL(config.url).origin;
    this.elementId = config.elementId;
  }

  sendMessage(message) {
    const element = window.document.getElementById(this.elementId);
    element.contentWindow.postMessage(message, this.origin);
  }

  setListener(handlerFn) {
    window.addEventListener('message', (event) => {
      if (event.origin !== this.origin) return;

      handlerFn(event.data);
    });
  }
}

export default PostMessageBus;
